export default __webpack_public_path__ + "static/media/video-control-right.380797f5.svg";